function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9688 3.23438H13.0156V2.10938C13.0156 2.03203 12.9523 1.96875 12.875 1.96875H11.8906C11.8133 1.96875 11.75 2.03203 11.75 2.10938V3.23438H7.25V2.10938C7.25 2.03203 7.18672 1.96875 7.10938 1.96875H6.125C6.04766 1.96875 5.98438 2.03203 5.98438 2.10938V3.23438H3.03125C2.72012 3.23438 2.46875 3.48574 2.46875 3.79688V15.4688C2.46875 15.7799 2.72012 16.0312 3.03125 16.0312H15.9688C16.2799 16.0312 16.5312 15.7799 16.5312 15.4688V3.79688C16.5312 3.48574 16.2799 3.23438 15.9688 3.23438ZM15.2656 14.7656H3.73438V8.08594H15.2656V14.7656ZM3.73438 6.89062V4.5H5.98438V5.34375C5.98438 5.42109 6.04766 5.48438 6.125 5.48438H7.10938C7.18672 5.48438 7.25 5.42109 7.25 5.34375V4.5H11.75V5.34375C11.75 5.42109 11.8133 5.48438 11.8906 5.48438H12.875C12.9523 5.48438 13.0156 5.42109 13.0156 5.34375V4.5H15.2656V6.89062H3.73438Z",
  fill: "#15A9E1"
});

var SvgCalendarWhite = function SvgCalendarWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-white.014a9efb.svg";
export { ForwardRef as ReactComponent };